
export const EXERCISE_ID = {
  BARBELL_BENCH_PRESS: 112,
  BARBELL_SQUAT: 162,
  BARBELL_DEADLIFT: 118
}
